import { ActionIcon, ThemeIcon } from '@mantine/core';
import { IconHistory } from '@tabler/icons-react';
import * as React from 'react';

import FieldSelect from '@/components/shared/form/FieldSelect';
import { useSidebarNewsStore } from '@/stores/local/sidebar/SidebarNewsStore';
import { useDevices } from '@/utils/devices';

import s from './NewsSelect.module.scss';

const NewsSelect: React.FC = () => {
  const { isCompactViewport } = useDevices();
  const { digestSelectStore } = useSidebarNewsStore();

  return (
    <FieldSelect
      afterSlot={
        isCompactViewport ? (
          <ActionIcon size={24} radius="xl" variant="transparent" c="gray" color="gray">
            <IconHistory />
          </ActionIcon>
        ) : (
          <ThemeIcon size={24} radius="xl" variant="light" gradient={{ from: 'blue', to: 'grape', deg: 135 }}>
            <IconHistory stroke={1} />
          </ThemeIcon>
        )
      }
      size="md"
      className={s.root}
      store={digestSelectStore}
    />
  );
};

export default React.memo(NewsSelect);
